<template>
  <v-container>
    <v-row>
      <v-col md="3">
        <v-card color="indigo" dark>
          <v-card-title>
            Экран на входе
          </v-card-title>
          <v-card-text>
            <v-list-item to='/meetups/room1' >
              Первая комната
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right</v-icon>
            </v-list-item>
            <v-list-item to='/meetups/room2' >
              Вторая комната
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right</v-icon>
            </v-list-item>
            <v-list-item to='/meetups/room3' >
              Третья комната
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right</v-icon>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card color="teal" dark>
          <v-card-title>
            Экран внутри
          </v-card-title>
          <v-card-text>
            <v-list-item to='/orders/new/room1' >
              Первая комната
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right</v-icon>
            </v-list-item>
            <v-list-item to='/orders/new/room2' >
              Вторая комната
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right</v-icon>
            </v-list-item>
            <v-list-item to='/orders/new/room3' >
              Третья комната
              <v-spacer></v-spacer>
              <v-icon right>mdi-arrow-right</v-icon>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card color="cyan" dark>
          <v-card-title>
            Записи
            <v-icon right>mdi-list</v-icon>
          </v-card-title>
          <v-card-text>

            <v-list-item>
              <v-chip color="white" text-color="indigo">
                <strong>всего:</strong>
                <v-avatar right color="grey lighten-3">
                  {{ meetupsAll.length }}
                </v-avatar>
              </v-chip>
            </v-list-item>

            <v-list-item>
              <v-chip color="white" text-color="green">
                <strong>прошло:</strong>
                <v-avatar right class="grey lighten-2">
                  {{ meetupsFinished.length }}
                </v-avatar>
              </v-chip>
            </v-list-item>

            <v-list-item>
              <v-chip color="white" text-color="red">
                <strong>в очереди:</strong>
                <v-avatar right class="grey lighten-2">
                  {{ meetupsComing.length }}
                </v-avatar>
              </v-chip>
            </v-list-item>

          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card color="pink" dark>
          <v-card-title>
            Заказы
            <v-icon right>mdi-list</v-icon>
          </v-card-title>
          <v-card-text>

            <v-list-item>
              <v-chip color="white" text-color="indigo">
                <strong>всего:</strong>
                <v-avatar right color="grey lighten-3">
                  {{ ordersAll.length }}
                </v-avatar>
              </v-chip>
            </v-list-item>

            <v-list-item>
              <v-chip color="white" text-color="green">
                <strong>выполнено:</strong>
                <v-avatar right class="grey lighten-2">
                  {{ ordersFinished.length }}
                </v-avatar>
              </v-chip>
            </v-list-item>

            <v-list-item>
              <v-chip color="white" text-color="red">
                <strong>в очереди:</strong>
                <v-avatar right class="grey lighten-2">
                  {{ ordersComing.length }}
                </v-avatar>
              </v-chip>
            </v-list-item>

          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>


export default {
  data(){
    return {
      
    }
  },
  methods: {
    
  },
  computed: {
    meetupsAll(){
      return this.$store.getters.loadedMeetups;
    },
    meetupsFinished(){
      return this.$store.getters.loadedMeetups
            .filter(meetup => +(new Date().getTime()) > (+meetup.timestamp + meetup.duration * 60 * 1000));
    },
    meetupsComing(){
      return this.$store.getters.loadedMeetups
            .filter(meetup => +(new Date().getTime()) < (+meetup.timestamp + meetup.duration * 60 * 1000));
    },
    ordersAll(){
      return this.$store.getters.loadedOrders;
    },
    ordersFinished(){
      return this.$store.getters.loadedOrders
            .filter(order => order.status == false);
    },
    ordersComing(){
      return this.$store.getters.loadedOrders
            .filter(order => order.status == true);
    },
  },
  created(){
    this.$store.dispatch('loadMeetups');
    this.$store.dispatch('loadOrders');
  }
}

</script>

<style scoped>

</style>
